export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10636.5e3769ee.jpg";